import { DatabaseOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Alert, Button, Col, Empty, Row, Space, Spin, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Permission } from '@aid/shared';
import { useHasPermission } from '../../auth/useHasPermission';
import { PageHeader } from '../../components/PageHeader';
import { useCategoriasList } from './api/useCatalogosAdmin';
import { CatalogCategoryCard } from './components/CatalogCategoryCard';

const { Text } = Typography;

export function CatalogosListPage() {
  const navigate = useNavigate();
  const canCreate = useHasPermission(Permission.CATALOGOS_CREATE);
  const canUpdate = useHasPermission(Permission.CATALOGOS_UPDATE);
  const { data: categories, isLoading, isError, refetch } = useCategoriasList();
  const visibleCategories = (categories ?? []).filter(
    (category) => category.active && category.behavior.visibleInHub,
  );

  return (
    <div>
      <PageHeader
        title="Catálogos"
        subtitle="Elegí una categoría para administrar sus valores y relaciones."
        actions={
          canCreate ? (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate('/catalogos/category/new')}
            >
              Nueva categoría
            </Button>
          ) : undefined
        }
      />

      {isLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 56 }}>
          <Spin size="large" />
        </div>
      )}

      {isError && (
        <Alert
          type="error"
          showIcon
          message="No se pudieron cargar las categorías"
          description="Reintentá la operación. Si el problema persiste, revisá la configuración del catálogo."
          action={
            <Button size="small" icon={<ReloadOutlined />} onClick={() => void refetch()}>
              Reintentar
            </Button>
          }
        />
      )}

      {!isLoading && !isError && visibleCategories.length === 0 && (
        <Empty
          image={<DatabaseOutlined style={{ fontSize: 40 }} />}
          description={
            <Space orientation="vertical" size={4}>
              <Text strong>No hay categorías disponibles</Text>
              <Text type="secondary">Creá una categoría para comenzar a administrar valores.</Text>
            </Space>
          }
        />
      )}

      {!isLoading && !isError && visibleCategories.length > 0 && (
        <Row gutter={[16, 16]}>
          {visibleCategories.map((category) => (
            <Col key={category.code} xs={24} sm={12} xl={8} xxl={6}>
              <CatalogCategoryCard
                category={category}
                onOpen={(code) => navigate(`/catalogos/category/${encodeURIComponent(code)}`)}
                onEdit={
                  canUpdate
                    ? (code) => navigate(`/catalogos/category/${encodeURIComponent(code)}/edit`)
                    : undefined
                }
              />
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
}
